// Mixin local (NÃO é Vue.mixin global — importe e declare em `mixins: []`).
// Um único tick por instância; sempre limpo no beforeUnmount.
export default {
  data() {
    return {
      segundosRestantes: 0,
      contagemTick: null,
    };
  },

  computed: {
    contagemFormatada() {
      const total = Math.max(0, this.segundosRestantes);
      const m = Math.floor(total / 60);
      const s = total % 60;
      return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    },

    contagemExpirada() {
      return this.segundosRestantes <= 0;
    },
  },

  beforeUnmount() {
    this.pararContagem();
  },

  methods: {
    /**
     * @param {?string} expiraEmIso timestamp ISO-8601 absoluto vindo do backend
     */
    iniciarContagem(expiraEmIso) {
      this.pararContagem();

      const alvo = expiraEmIso ? Date.parse(expiraEmIso) : NaN;
      if (isNaN(alvo)) {
        this.segundosRestantes = 0;
        return;
      }

      const recalcular = () => Math.max(0, Math.round((alvo - Date.now()) / 1000));

      this.segundosRestantes = recalcular();
      if (this.segundosRestantes <= 0) return;

      // Recalcula contra o relógio (em vez de decrementar) — aba em background
      // não deriva o contador.
      this.contagemTick = setInterval(() => {
        this.segundosRestantes = recalcular();
        if (this.segundosRestantes <= 0) this.pararContagem();
      }, 1000);
    },

    pararContagem() {
      if (this.contagemTick) {
        clearInterval(this.contagemTick);
        this.contagemTick = null;
      }
    },
  },
};
